import { useToggle } from 'admin';
import React from 'react';
import { Button } from 'ui';

import { SessionEvidenceEditDialog } from '../SessionEvidenceEditDialog/SessionEvidenceEditDialog';

export const SessionEditDialog = ({
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
}: {
  date: string;
  parentContentTypeId: number | null;
  parentId: number | null;
  uploadedById: number | null;
}) => {
  const { open, isOpen, close } = useToggle();

  return (
    <div>
      <Button onClick={open} disabled={!parentContentTypeId || !parentId}>
        Edit / Delete Evidence
      </Button>
      {parentContentTypeId && parentId ? (
        <SessionEvidenceEditDialog
          date={date}
          parentContentTypeId={parentContentTypeId}
          parentId={parentId}
          uploadedById={uploadedById}
          open={isOpen}
          onClose={close}
        />
      ) : null}
    </div>
  );
};
